import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm} from '@angular/forms';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-member-changed-dialog',
  templateUrl: './member-changed-dialog.component.html',
  styleUrls: [ './member-changed-dialog.component.scss' ]
})
export class MemberChangedDialogComponent implements OnInit {

  public Editor = ClassicEditor;
  
  public matcher = new FormErrorStateMatcher(); 
  public entityForm: FormGroup; 

  public spinner: boolean;

  constructor (
    private fb: FormBuilder,
    public matDialogRef: MatDialogRef<MemberChangedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.entityForm = this.createForm()
  }

  ngOnInit () {}

  createForm () {
    let form: FormGroup = this.fb.group({
      id: new FormControl(this.data.id),
      image: new FormControl(this.data.image),
      text: new FormControl(this.data.text),
    });
    return form
  }

}
